(function () {
  "use strict";

  var e = {
    425: function _(e, t, n) {
      var _r,
          s = this && this.__extends || (_r = function r(e, t) {
        return _r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }
        }, _r(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

        function n() {
          this.constructor = e;
        }

        _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          i = this && this.__assign || function () {
        return i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) {
            for (var s in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
            }
          }

          return e;
        }, i.apply(this, arguments);
      },
          o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (s, i) {
          function o(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }

          function a(e) {
            try {
              u(r.throw(e));
            } catch (e) {
              i(e);
            }
          }

          function u(e) {
            var t;
            e.done ? s(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(o, a);
          }

          u((r = r.apply(e, t || [])).next());
        });
      },
          a = this && this.__generator || function (e, t) {
        var n,
            r,
            s,
            i,
            o = {
          label: 0,
          sent: function sent() {
            if (1 & s[0]) throw s[1];
            return s[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; o;) {
                try {
                  if (n = 1, r && (s = 2 & i[0] ? r.return : i[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, i[1])).done) return s;

                  switch (r = 0, s && (i = [2 & i[0], s.value]), i[0]) {
                    case 0:
                    case 1:
                      s = i;
                      break;

                    case 4:
                      return o.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      o.label++, r = i[1], i = [0];
                      continue;

                    case 7:
                      i = o.ops.pop(), o.trys.pop();
                      continue;

                    default:
                      if (!((s = (s = o.trys).length > 0 && s[s.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        o = 0;
                        continue;
                      }

                      if (3 === i[0] && (!s || i[1] > s[0] && i[1] < s[3])) {
                        o.label = i[1];
                        break;
                      }

                      if (6 === i[0] && o.label < s[1]) {
                        o.label = s[1], s = i;
                        break;
                      }

                      if (s && o.label < s[2]) {
                        o.label = s[2], o.ops.push(i);
                        break;
                      }

                      s[2] && o.ops.pop(), o.trys.pop();
                      continue;
                  }

                  i = t.call(e, o);
                } catch (e) {
                  i = [6, e], r = 0;
                } finally {
                  n = s = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      },
          u = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, s = 0, i = t.length; s < i; s++) {
          !r && s in t || (r || (r = Array.prototype.slice.call(t, 0, s)), r[s] = t[s]);
        }
        return e.concat(r || Array.prototype.slice.call(t));
      },
          c = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.AddressSearchType = void 0;
      var d,
          h = n(405),
          l = n(64),
          p = n(574),
          f = n(674),
          v = n(543),
          y = c(n(956));
      !function (e) {
        e[e.EXTERNAL = 0] = "EXTERNAL", e[e.CHANGE = 1] = "CHANGE", e[e.EXTERNAL_OR_CHANGE = 2] = "EXTERNAL_OR_CHANGE";
      }(d = t.AddressSearchType || (t.AddressSearchType = {})), t.default = function (e) {
        var t = function (e) {
          function t() {
            for (var t = [], n = 0; n < arguments.length; n++) {
              t[n] = arguments[n];
            }

            var r = this,
                s = t[0],
                i = s.network,
                o = s.baseDerivationPath,
                a = s.addressType,
                u = void 0 === a ? l.bitcoin.AddressType.BECH32 : a,
                c = Object.values(l.bitcoin.AddressType);
            if (!c.includes(u)) throw new Error("addressType must be one of ".concat(c.join(",")));
            return (r = e.call(this, s) || this)._baseDerivationPath = o, r._network = i, r._addressType = u, r._derivationCache = {}, r;
          }

          return s(t, e), t.prototype.getDerivationCache = function () {
            return this._derivationCache;
          }, t.prototype.sendOptionsToOutputs = function (e) {
            var t = [];
            return e.forEach(function (e) {
              if (e.to && e.value && e.value.gt(0) && t.push({
                address: (0, p.addressToString)(e.to),
                value: e.value.toNumber()
              }), e.data) {
                var n = v.script.compile([v.script.OPS.OP_RETURN, Buffer.from(e.data, "hex")]);
                t.push({
                  value: 0,
                  script: n
                });
              }
            }), t;
          }, t.prototype.setDerivationCache = function (e) {
            return o(this, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, this.getDerivationPathAddress(Object.keys(e)[0])];

                  case 1:
                    if (t = n.sent(), e[t.derivationPath].address !== t.address) throw new Error("derivationCache at ".concat(t.derivationPath, " does not match"));
                    return this._derivationCache = e, [2];
                }
              });
            });
          }, t.prototype.buildTransaction = function (e, t) {
            return o(this, void 0, void 0, function () {
              return a(this, function (n) {
                return [2, this._buildTransaction([e], t)];
              });
            });
          }, t.prototype.buildBatchTransaction = function (e) {
            return o(this, void 0, void 0, function () {
              return a(this, function (t) {
                return [2, this._buildTransaction(e)];
              });
            });
          }, t.prototype._sendTransaction = function (e, t) {
            return o(this, void 0, void 0, function () {
              var n, r, s;
              return a(this, function (i) {
                switch (i.label) {
                  case 0:
                    return [4, this._buildTransaction(e, t)];

                  case 1:
                    return n = i.sent(), r = n.hex, s = n.fee, [4, this.getMethod("sendRawTransaction")(r)];

                  case 2:
                    return i.sent(), [2, (0, h.normalizeTransactionObject)((0, h.decodeRawTransaction)(r, this._network), s)];
                }
              });
            });
          }, t.prototype.sendTransaction = function (e) {
            return o(this, void 0, void 0, function () {
              return a(this, function (t) {
                return [2, this._sendTransaction(this.sendOptionsToOutputs([e]), e.fee)];
              });
            });
          }, t.prototype.sendBatchTransaction = function (e) {
            return o(this, void 0, void 0, function () {
              return a(this, function (t) {
                return [2, this._sendTransaction(this.sendOptionsToOutputs(e))];
              });
            });
          }, t.prototype.buildSweepTransaction = function (e, t) {
            return o(this, void 0, void 0, function () {
              return a(this, function (n) {
                return [2, this._buildSweepTransaction(e, t)];
              });
            });
          }, t.prototype.sendSweepTransaction = function (e, t) {
            return o(this, void 0, void 0, function () {
              var n, r, s;
              return a(this, function (i) {
                switch (i.label) {
                  case 0:
                    return [4, this._buildSweepTransaction((0, p.addressToString)(e), t)];

                  case 1:
                    return n = i.sent(), r = n.hex, s = n.fee, [4, this.getMethod("sendRawTransaction")(r)];

                  case 2:
                    return i.sent(), [2, (0, h.normalizeTransactionObject)((0, h.decodeRawTransaction)(r, this._network), s)];
                }
              });
            });
          }, t.prototype.updateTransactionFee = function (e, t) {
            return o(this, void 0, void 0, function () {
              var n, r, s, i, o, u, c, d, p, f, v;
              return a(this, function (a) {
                switch (a.label) {
                  case 0:
                    return n = "string" == typeof e ? e : e.hash, [4, this.getMethod("getTransactionByHash")(n)];

                  case 1:
                    return r = a.sent()._raw, s = [r.vin[0]], i = r.vout.map(function (e) {
                      return e.scriptPubKey.addresses[0];
                    }), [4, this.findAddress(i, !0)];

                  case 2:
                    return o = a.sent(), u = r.vout.find(function (e) {
                      return e.scriptPubKey.addresses[0] === o.address;
                    }), c = r.vout, u && (c = c.filter(function (e) {
                      return e.scriptPubKey.addresses[0] !== u.scriptPubKey.addresses[0];
                    })), d = c.map(function (e) {
                      return {
                        address: e.scriptPubKey.addresses[0],
                        value: new l.BigNumber(e.value).times(1e8).toNumber()
                      };
                    }), [4, this._buildTransaction(d, t, s)];

                  case 3:
                    return p = a.sent(), f = p.hex, v = p.fee, [4, this.getMethod("sendRawTransaction")(f)];

                  case 4:
                    return a.sent(), [2, (0, h.normalizeTransactionObject)((0, h.decodeRawTransaction)(f, this._network), v)];
                }
              });
            });
          }, t.prototype.findAddress = function (e, t) {
            return void 0 === t && (t = !1), o(this, void 0, void 0, function () {
              var n, r, s, i, o;
              return a(this, function (a) {
                switch (a.label) {
                  case 0:
                    n = 1, r = 50, s = 0, a.label = 1;

                  case 1:
                    return s < n ? [4, this.getAddresses(s, r, t)] : [3, 3];

                  case 2:
                    return i = a.sent(), (o = i.find(function (t) {
                      return e.find(function (e) {
                        return t.address === e;
                      });
                    })) ? [2, o] : (s += r, [3, 1]);

                  case 3:
                    return [2];
                }
              });
            });
          }, t.prototype.getWalletAddress = function (e) {
            return o(this, void 0, void 0, function () {
              var t, n;
              return a(this, function (r) {
                switch (r.label) {
                  case 0:
                    return [4, this.findAddress([e], !1)];

                  case 1:
                    return (t = r.sent()) ? [2, t] : [4, this.findAddress([e], !0)];

                  case 2:
                    if (n = r.sent()) return [2, n];
                    throw new Error("Wallet does not contain address");
                }
              });
            });
          }, t.prototype.getAddressFromPublicKey = function (e) {
            return this.getPaymentVariantFromPublicKey(e).address;
          }, t.prototype.getPaymentVariantFromPublicKey = function (e) {
            return this._addressType === l.bitcoin.AddressType.LEGACY ? v.payments.p2pkh({
              pubkey: e,
              network: this._network
            }) : this._addressType === l.bitcoin.AddressType.P2SH_SEGWIT ? v.payments.p2sh({
              redeem: v.payments.p2wpkh({
                pubkey: e,
                network: this._network
              }),
              network: this._network
            }) : this._addressType === l.bitcoin.AddressType.BECH32 ? v.payments.p2wpkh({
              pubkey: e,
              network: this._network
            }) : void 0;
          }, t.prototype.importAddresses = function () {
            return o(this, void 0, void 0, function () {
              var e, t, n;
              return a(this, function (r) {
                switch (r.label) {
                  case 0:
                    return [4, this.getAddresses(0, 200, !0)];

                  case 1:
                    return e = r.sent(), [4, this.getAddresses(0, 200, !1)];

                  case 2:
                    return t = r.sent(), n = u(u([], t, !0), e, !0).map(function (e) {
                      return e.address;
                    }), [4, this.getMethod("importAddresses")(n)];

                  case 3:
                    return r.sent(), [2];
                }
              });
            });
          }, t.prototype.getDerivationPathAddress = function (e) {
            return o(this, void 0, void 0, function () {
              var t, n, r, s, i;
              return a(this, function (o) {
                switch (o.label) {
                  case 0:
                    return e in this._derivationCache ? [2, this._derivationCache[e]] : [4, this.baseDerivationNode()];

                  case 1:
                    return t = o.sent(), n = e.replace(this._baseDerivationPath + "/", ""), r = t.derivePath(n).publicKey, s = this.getAddressFromPublicKey(r), i = new l.Address({
                      address: s,
                      publicKey: r.toString("hex"),
                      derivationPath: e
                    }), this._derivationCache[e] = i, [2, i];
                }
              });
            });
          }, t.prototype.getAddresses = function (e, t, n) {
            return void 0 === e && (e = 0), void 0 === t && (t = 1), void 0 === n && (n = !1), o(this, void 0, void 0, function () {
              var r, s, i, o, u, c, d;
              return a(this, function (a) {
                switch (a.label) {
                  case 0:
                    if (t < 1) throw new Error("You must return at least one address");
                    r = [], s = e + t, i = n ? "1" : "0", o = e, a.label = 1;

                  case 1:
                    return o < s ? (u = i + "/" + o, c = this._baseDerivationPath + "/" + u, [4, this.getDerivationPathAddress(c)]) : [3, 5];

                  case 2:
                    return d = a.sent(), r.push(d), [4, (0, p.asyncSetImmediate)()];

                  case 3:
                    a.sent(), a.label = 4;

                  case 4:
                    return o++, [3, 1];

                  case 5:
                    return [2, r];
                }
              });
            });
          }, t.prototype._getUsedUnusedAddresses = function (e, t) {
            return void 0 === e && (e = 1), o(this, void 0, void 0, function () {
              var n, r, s, i, o, u, c, h, l, p, f, v, y, b, g, w;
              return a(this, function (a) {
                switch (a.label) {
                  case 0:
                    n = [], r = {
                      change: 0,
                      external: 0
                    }, s = {
                      change: null,
                      external: null
                    }, i = {
                      change: 0,
                      external: 0
                    }, u = [], c = 0, h = [], l = [], a.label = 1;

                  case 1:
                    return t === d.EXTERNAL_OR_CHANGE && (r.change < 1 && i.change < 1 || r.external < 1 && i.external < 1) || t === d.EXTERNAL && r.external < 1 && i.external < 1 || t === d.CHANGE && r.change < 1 && i.change < 1 ? (o = [], (t === d.EXTERNAL_OR_CHANGE || t === d.CHANGE) && r.change < 1 && i.change < 1 ? [4, this.getAddresses(c, e, !0)] : [3, 3]) : [3, 7];

                  case 2:
                    p = a.sent(), h = h.concat(p), o = o.concat(p), i.change += e, a.label = 3;

                  case 3:
                    return (t === d.EXTERNAL_OR_CHANGE || t === d.EXTERNAL) && r.external < 1 && i.external < 1 ? [4, this.getAddresses(c, e, !1)] : [3, 5];

                  case 4:
                    p = a.sent(), l = l.concat(p), o = o.concat(p), i.external += e, a.label = 5;

                  case 5:
                    return [4, this.getMethod("getAddressTransactionCounts")(o)];

                  case 6:
                    for (f = a.sent(), v = function v(e) {
                      if (u.includes(e.address)) return "continue";
                      u.push(e.address);
                      var t = f[e.address] > 0,
                          i = h.find(function (t) {
                        return e.address === t.address;
                      }) ? "change" : "external";
                      t ? (n.push(e), r[i] = 0, s[i] = null) : (r[i]++, s[i] || (s[i] = e));
                    }, y = 0, b = o; y < b.length; y++) {
                      g = b[y], v(g);
                    }

                    return c += e, [3, 1];

                  case 7:
                    return s.change || (w = h.length - 1, s.change = h[Math.round(Math.random() * w)]), s.external || (w = l.length - 1, s.external = l[Math.round(Math.random() * w)]), [2, {
                      usedAddresses: n,
                      unusedAddress: s
                    }];
                }
              });
            });
          }, t.prototype.getUsedAddresses = function (e) {
            return void 0 === e && (e = 1), o(this, void 0, void 0, function () {
              return a(this, function (t) {
                return [2, this._getUsedUnusedAddresses(e, d.EXTERNAL_OR_CHANGE).then(function (e) {
                  return e.usedAddresses;
                })];
              });
            });
          }, t.prototype.getUnusedAddress = function (e, t) {
            return void 0 === e && (e = !1), void 0 === t && (t = 1), o(this, void 0, void 0, function () {
              var n, r;
              return a(this, function (s) {
                return n = e ? d.CHANGE : d.EXTERNAL, r = e ? "change" : "external", [2, this._getUsedUnusedAddresses(t, n).then(function (e) {
                  return e.unusedAddress[r];
                })];
              });
            });
          }, t.prototype.withCachedUtxos = function (e) {
            return o(this, void 0, void 0, function () {
              var t,
                  n,
                  r,
                  s,
                  i,
                  o = this;
              return a(this, function (a) {
                switch (a.label) {
                  case 0:
                    return t = this.getMethod, n = (0, y.default)(this.getMethod("getFeePerByte"), {
                      primitive: !0
                    }), r = (0, y.default)(this.getMethod("getUnspentTransactions"), {
                      primitive: !0
                    }), s = (0, y.default)(this.getMethod("getAddressTransactionCounts"), {
                      primitive: !0
                    }), this.getMethod = function (e, i) {
                      return void 0 === i && (i = o), "getFeePerByte" === e ? n : "getUnspentTransactions" === e ? r : "getAddressTransactionCounts" === e ? s : t.bind(o)(e, i);
                    }, [4, e.bind(this)()];

                  case 1:
                    return i = a.sent(), this.getMethod = t, [2, i];
                }
              });
            });
          }, t.prototype.getTotalFee = function (e, t) {
            return o(this, void 0, void 0, function () {
              var n;
              return a(this, function (r) {
                switch (r.label) {
                  case 0:
                    return n = this.sendOptionsToOutputs([e]), t ? [3, 2] : [4, this.getInputsForAmount(n, e.fee)];

                  case 1:
                  case 3:
                    return [2, r.sent().fee];

                  case 2:
                    return [4, this.getInputsForAmount(n.filter(function (e) {
                      return !e.value;
                    }), e.fee, [], !0)];
                }
              });
            });
          }, t.prototype.getTotalFees = function (e, t) {
            return o(this, void 0, void 0, function () {
              var n = this;
              return a(this, function (r) {
                switch (r.label) {
                  case 0:
                    return [4, this.withCachedUtxos(function () {
                      return o(n, void 0, void 0, function () {
                        var n, r, s, i, o;
                        return a(this, function (a) {
                          switch (a.label) {
                            case 0:
                              n = {}, r = 0, s = e, a.label = 1;

                            case 1:
                              return r < s.length ? (i = s[r], [4, this.getTotalFee(i, t)]) : [3, 4];

                            case 2:
                              o = a.sent(), n[i.fee] = new l.BigNumber(o), a.label = 3;

                            case 3:
                              return r++, [3, 1];

                            case 4:
                              return [2, n];
                          }
                        });
                      });
                    })];

                  case 1:
                    return [2, r.sent()];
                }
              });
            });
          }, t.prototype.getInputsForAmount = function (e, t, n, r) {
            return void 0 === n && (n = []), void 0 === r && (r = !1), o(this, void 0, void 0, function () {
              var s, o, u, c, d, p, v, y, b, g, w, _, T, A, m, E, x, P, N, O, C, R, M, k, B, S, F, H, U;

              return a(this, function (a) {
                switch (a.label) {
                  case 0:
                    return s = this.getMethod("getFeePerByte")(), o = [], [4, this.getUsedAddresses()];

                  case 1:
                    if (u = a.sent(), c = [], !(n.length > 0)) return [3, 6];
                    d = 0, p = n, a.label = 2;

                  case 2:
                    return d < p.length ? (v = p[d], [4, this.getMethod("getRawTransactionByHash")(v.txid)]) : [3, 6];

                  case 3:
                    return y = a.sent(), b = (0, h.decodeRawTransaction)(y, this._network), g = new l.BigNumber(b.vout[v.vout].value).times(1e8).toNumber(), w = b.vout[v.vout].scriptPubKey.addresses[0], [4, this.getWalletAddress(w)];

                  case 4:
                    _ = a.sent(), T = i(i({}, v), {
                      value: g,
                      address: w,
                      derivationPath: _.derivationPath
                    }), c.push(T), a.label = 5;

                  case 5:
                    return d++, [3, 2];

                  case 6:
                    return r && 0 !== c.length ? [3, 8] : [4, this.getMethod("getUnspentTransactions")(u)];

                  case 7:
                    return A = a.sent(), o.push.apply(o, A.map(function (e) {
                      var t = u.find(function (t) {
                        return t.address === e.address;
                      });
                      return i(i({}, e), {
                        derivationPath: t.derivationPath
                      });
                    })), [3, 9];

                  case 8:
                    o = c, a.label = 9;

                  case 9:
                    return m = o.reduce(function (e, t) {
                      return e + (t.value || 0);
                    }, 0), t ? [3, 11] : [4, s];

                  case 10:
                    t = a.sent(), a.label = 11;

                  case 11:
                    return [4, this.getMethod("getMinRelayFee")()];

                  case 12:
                    if (E = a.sent(), t < E) throw new Error("Fee supplied (".concat(t, " sat/b) too low. Minimum relay fee is ").concat(E, " sat/b"));
                    if (r ? (P = e.reduce(function (e, t) {
                      return e + (t.value || 0);
                    }, 0), N = 39 * e.filter(function (e) {
                      return e.value && e.address;
                    }).length, O = e.filter(function (e) {
                      return !e.value && e.script;
                    }).reduce(function (e, t) {
                      return e + 39 + t.script.byteLength;
                    }, 0), C = 39 + N + O, R = 153 * o.length, M = t * (R + C), k = new l.BigNumber(m).minus(M), (x = e.map(function (e) {
                      return {
                        id: "main",
                        value: e.value,
                        script: e.script
                      };
                    })).push({
                      id: "main",
                      value: k.minus(P).toNumber()
                    })) : x = e.map(function (e) {
                      return {
                        id: "main",
                        value: e.value,
                        script: e.script
                      };
                    }), B = (0, h.selectCoins)(o, x, Math.ceil(t), c), S = B.inputs, F = B.outputs, H = B.change, U = B.fee, S && F) return [2, {
                      inputs: S,
                      change: H,
                      outputs: F,
                      fee: U
                    }];
                    throw new f.InsufficientBalanceError("Not enough balance");
                }
              });
            });
          }, t;
        }(e);

        return t;
      };
    },
    175: function _(e, t, n) {
      var r = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.BitcoinWalletProvider = void 0;
      var s = r(n(425));
      t.BitcoinWalletProvider = s.default;
    },
    405: function _(e) {
      e.exports = require("@yaswap/bitcoin-utils");
    },
    674: function _(e) {
      e.exports = require("@yaswap/errors");
    },
    64: function _(e) {
      e.exports = require("@yaswap/types");
    },
    574: function _(e) {
      e.exports = require("@yaswap/utils");
    },
    543: function _(e) {
      e.exports = require("bitcoinjs-lib");
    },
    956: function _(e) {
      e.exports = require("memoizee");
    }
  },
      t = {},
      n = function n(r) {
    var s = t[r];
    if (void 0 !== s) return s.exports;
    var i = t[r] = {
      exports: {}
    };
    return e[r].call(i.exports, i, i.exports, n), i.exports;
  }(175);

  module.exports = n;
})();